import React, { useState, useEffect } from 'react';
import { Container, Typography, Grid, Card, CardContent, CardActions, Button, Chip, Box, CircularProgress, Alert } from '@mui/material';
import { fetchClasses, bookClass } from '../api/client';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonIcon from '@mui/icons-material/Person';
import { useNavigate } from 'react-router-dom';

const ClassesPage = () => {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await fetchClasses();
        setClasses(data);
      } catch (err) {
        setError('Failed to load classes.');
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const handleBook = (classItem) => {
    // Save intended event to open detail view on Schedule Page
    localStorage.setItem('pendingBookingEventId', classItem.id);
    navigate('/schedule');
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Container sx={{ py: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Typography variant="h3" gutterBottom sx={{ fontWeight: 800, color: 'primary.main', mb: 4 }}>
        Our Classes
      </Typography>

      <Grid container spacing={4}>
        {classes.length === 0 ? (
          <Grid item xs={12}><Typography>No classes scheduled yet.</Typography></Grid>
        ) : classes.map((cls) => (
          <Grid item xs={12} sm={6} md={4} key={cls.id}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', borderRadius: 4, transition: '0.3s', '&:hover': { boxShadow: 6 } }}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Chip
                  label={cls.track || 'General'}
                  size="small"
                  color="secondary"
                  sx={{ mb: 2, fontWeight: 'bold', borderRadius: 1 }}
                />
                <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 700 }}>
                  {cls.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  {cls.description}
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2, color: 'text.secondary' }}>
                  <PersonIcon fontSize="small" />
                  <Typography variant="body2">{cls.instructor}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1, color: 'text.secondary' }}>
                  <AccessTimeIcon fontSize="small" />
                  <Typography variant="body2">
                    {new Date(cls.schedule_time).toLocaleDateString()} at {new Date(cls.schedule_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                  </Typography>
                </Box>
              </CardContent>
              <CardActions sx={{ p: 2, pt: 0 }}>
                <Button
                  size="large"
                  variant="contained"
                  fullWidth
                  sx={{ borderRadius: 2 }}
                  onClick={() => handleBook(cls)}
                >
                  Book Class ({cls.price_credits || 1} Credit)
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ClassesPage;
